<template>
  <table
    class="table zero-configuration"
    :aria-label="$t('contract_templates_Contact_template_list')"
  >
    <thead>
      <tr>
        <th>{{ $t("Name") }}</th>
        <th>{{ $t("Type") }}</th>
        <th>{{ $t("Status") }}</th>
        <th>{{ $t("Last edited by") }}</th>
        <th>{{ $t("Country") }}</th>
        <th>{{ $t("Created At") }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(template, index) in templates" :key="index">
        <td class="templateName capitalize">
          {{ template.details.en.name || template.details.en.title }}
          <br />
          <small
            >{{ $t("Last edit") }}:
            {{ template.lastEditedAt.split("T")[0] }}</small
          >
          <br />
          <a
            href="#"
            @click="editTemplateModal(template.uid)"
            style="margin-top: 5px"
          >
            <em class="bx bx-edit-alt"></em> {{ $t("Edit") }}
          </a>
        </td>
        <td v-if="template.type === 'standard_residential'">
          {{ $t("Standard Residential Lease") }}
        </td>
        <td v-if="template.type === 'free_occupancy'">
          {{ $t("Occupancy Free of Charge Lease") }}
        </td>
        <td v-if="template.type === 'rent_reduction'">
          {{ $t("Rent Reduction Lease") }}
        </td>
        <td class="capitalize">
          <span v-if="template.status == 'draft'">
            <em class="bx bxs-circle light-secondary font-small-1 mr-50"></em>
            {{ template.status }}
          </span>
          <span v-if="template.status == 'published'">
            <em class="bx bxs-circle success font-small-1 mr-50"></em>
            {{ template.status }}
          </span>
          <span v-if="template.status == 'archived'">
            <em class="bx bxs-circle warning font-small-1 mr-50"></em>
            {{ template.status }}
          </span>
        </td>
        <td>
          {{
            template.lastEditedByUser && template.lastEditedByUser.name
              ? template.lastEditedByUser.name
              : "-"
          }}
        </td>
        <td>{{ countryName(template.country) }}</td>
        <td>{{ template.createdAt.split("T")[0] }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["templates","countryName","editTemplateModal"],
};
</script>

<style scoped>

.zero-configuration td {
  white-space: nowrap;
}

.zero-configuration th {
  white-space: nowrap;
}

</style>
